module.exports = __webpack_public_path__ + "img/money_red.4e87bd4d.png";